import type { PreviewUploadView } from '../types/views';

/**
 * Views where the Next button is disabled and `_onNext` no-ops.
 * Single source of truth for both the step function footer and the orchestrator guard.
 */
export const NEXT_BLOCKING_VIEWS: ReadonlySet<PreviewUploadView> = new Set([
  'all-invalid',
  'processing',
  'processing-delay',
]);
